module.exports = __webpack_public_path__ + "f89071a55de9479417676e727c684695.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/MC.svg
// module id = Z2Px
// module chunks = 0